export default {
  COPYRIGHT: 'copyright',
};
